import { IApplicationState } from '../../types/redux';
import { selectProjectName } from './selectProjectName';

export const selectProjectTitle = (state: IApplicationState) => {
  const projectName = selectProjectName(state);

  return `Проект дома «${projectName}»`;
};
